import React, { useEffect, useState } from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import "jspdf-autotable";
import CardBox from "./CardBox";
import WithLoading from "../../../../utils/WithLoading";
import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { buttonColors } from "../../../../utils/enum";
import {
  createAlertConfigInfo,
  deleteAlertConfigInfo,
  fetchAlertConfigInfo,
  updateAlertAvailabilityInfo,
  updateAlertConfigInfo,
} from "../../../../services/insightApp/metrics";
import { useRouteMatch } from "react-router-dom";
import {
  ERROR_MESSAGE_UNEXPECTED_ERROR,
  ERROR_MESSAGE_UPDATING_ERROR,
  SUCCESSFULLY_CREATED,
  SUCCESSFULLY_UPDATED,
} from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import CreateNewNode from "./CreateNewNode";
import AlertConfigModal from "./AlertConfigModal";
import CardCommon from "../../../../components/card/CardCommon";
import AlertConfigEditModal from "./AlertConfigEditModal";
import OpeningTimeSlot from "../../../../components/opening-times/EditOpeningTimesDialog/OpeningTimeSlot";
import {
  combineMinuteOfWeekArrays,
  deconstructMinuteOfWeekArray,
  getOpenCloseTimesList,
  normalizeTimeSelections,
} from "../../../../utils/time-conversions";
import _ from "lodash";

interface AlertConfigNodeProps {
  isLoading: boolean;
  alertConfigInfo: any;
  availabilityList: any;getAlertAvailabilityInfo:any
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 12,
      padding: 16,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "self-start",
      flex: 1,
    },
    radioBtn: {
      display: "flex",
    },
    daysSection: {
      display: "flex",
    },
    days: {
      marginRight: 16,
    },
  }),
);

const AlertConfigNode: React.FC<AlertConfigNodeProps> = ({
  isLoading,
  alertConfigInfo,
  availabilityList,getAlertAvailabilityInfo
}) => {
  const [openingTimesSelectionList, setOpeningTimesSelectionList] =
    useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  useEffect(() => {
    // if (!open) return;
    let weekly = availabilityList?.weekly;
    if (Array.isArray(weekly)) {
      const openCloseTimes = getOpenCloseTimesList(weekly);
      const deconstructedMinuteOfWeekArray = deconstructMinuteOfWeekArray(
        availabilityList.weekly,
        openCloseTimes,
      );
      setOpeningTimesSelectionList(deconstructedMinuteOfWeekArray);
    }
  }, [availabilityList.weekly]);

  /* Close the opening time selection modal */
  const handleClose = () => {
    setOpen(false);
  };

  const isAlertConfigEmpty = (input: any[]): boolean => {
    return input.every((item) => item.alertConfig);
  };

  /* Update the opening time shedule */
  const handleSubmit = async () => {
    try {
      /* availabilitySelectionList = [{openTime: '11:49', closeTime: '11:49', id: 2, 
                                             nodeList: [{minuteOfWeek: 3589, durationMins: 1440, day: 'tue', openTime: '11:49', closeTime: '11:49'},
                                                        {minuteOfWeek: 6469, durationMins: 1440, day: 'thu', openTime: '11:49', closeTime: '11:49'}]}]
               combinedMowArrays = {tue: [{minuteOfWeek: 3589, durationMins: 1440, day: 'tue', openTime: '11:49', closeTime: '11:49'},
                                    thu:  {minuteOfWeek: 6469, durationMins: 1440, day: 'thu', openTime: '11:49', closeTime: '11:49'}]} */
      const combinedMowArrays: any = combineMinuteOfWeekArrays(
        openingTimesSelectionList,
      );
      let normalizedArray = _.cloneDeep(combinedMowArrays);

      // Remove select same date range in same same date.
      Object.keys(combinedMowArrays).forEach((day) => {
        normalizedArray[day] = normalizeTimeSelections(normalizedArray[day]);
      });

      // Convert array to minute of week array
      const mowArray = Object.values(normalizedArray).flat();
      const data = _.cloneDeep(availabilityList);
      data.weekly = mowArray;

      const isEmpty = isAlertConfigEmpty(mowArray);
      if (!isEmpty) {
        setError("Please select alert configuration.");
        return;
      }

      if (mowArray.length === 0) {
        setError("Please select date.");
        return;
      }
      await updateAlertAvailabilityInfo(locationId, mowArray);
      getAlertAvailabilityInfo();
      setSuccess(SUCCESSFULLY_UPDATED);
      // await updateOpeningTimeSchedule(
      //   locationId,
      //   openingTimesSchedule.id,
      //   data,
      // );
      // fetchOpeningTimes();
      setOpen(false);
    } catch (error) {
      setError(ERROR_MESSAGE_UPDATING_ERROR);
    }
  };

  /* Create new time slot UI using initial data. */
  const handleAdd = () => {
    setOpeningTimesSelectionList([
      ...openingTimesSelectionList,
      {
        closeTime: "22:00",
        id: Math.random(),
        nodeList: [],
        openTime: "08:00",
      },
    ]);
  };

  /* Open the opening time selection modal */
  const handleClickOpen = () => {
    setOpen(true);
  };

  const openCloseTimes = getOpenCloseTimesList(availabilityList?.weekly);
  const deconstructedMinuteOfWeekArray = deconstructMinuteOfWeekArray(
    availabilityList?.weekly,
    openCloseTimes,
  );

  const handleAlertConfig = (alertConfig: any) => {
    if (alertConfigInfo) {
      const filter = alertConfigInfo.filter(
        (item: any) => item.id === alertConfig,
      );
      return filter?.[0]?.label;
    }
  };
  const classes = useStyles();
  return (
    <>
      <CardCommon
        backgroundColor={"entity_highlight_background"}
        style={{ margin: "8px 0" }}
      >
        <div className={classes.root}>
          <div className={classes.content}>
            <div className={classes.daysSection}>
              {deconstructedMinuteOfWeekArray.map((node) => (
                <div className={classes.days} key={node.toString()}>
                  <Typography variant={"subtitle2"}>
                    {node.nodeList
                      .map((openTimeNode: any) => _.startCase(openTimeNode.day))
                      .join(", ")}
                  </Typography>
                  <Typography variant={"body2"}>
                    {node.openTime} - {node.closeTime}
                  </Typography>
                  <Typography variant={"body2"}>
                    {handleAlertConfig(node.nodeList[0].alertConfig)}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
          <div className={classes.radioBtn}>
            <Button
              variant={"text"}
              color="secondary"
              onClick={handleClickOpen}
            >
              Edit
            </Button>
            <Dialog
              maxWidth={"md"}
              fullWidth={true}
              open={open}
              onClose={handleClose}
            >
              <CardCommon backgroundColor={"entity_background"}>
                <div>
                  <DialogTitle id="alert-dialog-title">
                    {"Set Hours"}
                  </DialogTitle>
                  <div style={{ padding: 16 }}>
                    {openingTimesSelectionList.map(
                      (openingTimeSelection: any, i: number) => (
                        <OpeningTimeSlot
                          openingTimesSelectionList={openingTimesSelectionList}
                          openingTimeSelection={openingTimeSelection}
                          setOpeningTimesSelectionList={
                            setOpeningTimesSelectionList
                          }
                          isNeedDropDown={true}
                          autocompleteData={alertConfigInfo}
                        />
                      ),
                    )}
                    <Button onClick={handleAdd} color="secondary">
                      Add +
                    </Button>
                  </div>
                  <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                      Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="secondary" autoFocus>
                      Apply
                    </Button>
                  </DialogActions>
                </div>
              </CardCommon>
            </Dialog>
            {/* <Typography
            variant="h6"
            align="left"
            style={{ paddingLeft: "16px", paddingTop: "16px" }}
          >
            Set Hours
          </Typography>
          <div style={{ padding: 16 }}>
            {openingTimesSelectionList.map(
              (openingTimeSelection: any, i: number) => (
                <OpeningTimeSlot
                  openingTimesSelectionList={openingTimesSelectionList}
                  openingTimeSelection={openingTimeSelection}
                  setOpeningTimesSelectionList={setOpeningTimesSelectionList}
                  isNeedDropDown={true}
                  autocompleteData={alertConfigInfo}
                />
              ),
            )}
            <Button
              onClick={handleAdd}
              color="secondary"
              style={{ display: "flex", justifyContent: "start" }}
            >
              Add +
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingBottom: "4px",
            }}
          >
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="secondary" autoFocus>
              Apply
            </Button>
          </div> */}
          </div>
        </div>
      </CardCommon>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />

      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity="success"
      />
    </>
  );
};

export default WithLoading(AlertConfigNode);
